import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface MarketingUserSport {
  name: string;
  level: number | null;
  maxLevel: number | null;
}

export interface MarketingUserRow {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  city: string;
  segment: string;
  createdAt: string | null;
  lastLoginAt: string | null;
  lastActionKind: 'created' | 'joined' | null;
  lastActionTitle: string | null;
  lastActionDaysSince: number | null;
  involvedCount: number;
  sports: MarketingUserSport[];
  hasPush: boolean;
  hasCustomNotifications: boolean;
  pushMarketing: boolean | null;
  pushReminder: boolean | null;
  pushProximity: boolean | null;
  mailMarketing: boolean | null;
}

export interface MarketingUsersFilters {
  page: number;
  limit: number;
  search?: string;
  segment?: string;
  reachableMarketing?: boolean;
}

/** The marketing view of the user base, one page at a time. */
@Injectable({ providedIn: 'root' })
export class MarketingUsersStoreService {
  #http = inject(HttpClient);

  readonly rows = signal<MarketingUserRow[]>([]);
  readonly total = signal(0);
  readonly segmentCounts = signal<Record<string, number>>({});
  readonly loading = signal(false);
  readonly failed = signal(false);

  load(filters: MarketingUsersFilters): void {
    this.loading.set(true);
    this.failed.set(false);

    let params = new HttpParams().set('page', filters.page).set('limit', filters.limit);
    if (filters.search?.trim()) params = params.set('search', filters.search.trim());
    if (filters.segment) params = params.set('segment', filters.segment);
    if (filters.reachableMarketing) params = params.set('reachableMarketing', 'true');

    this.#http
      .get<{ rows: MarketingUserRow[]; total: number; segmentCounts: Record<string, number> }>(
        `${environment.api}/api/v1/admin/users/marketing-list`,
        { params },
      )
      .subscribe({
        next: (res) => {
          this.loading.set(false);
          this.rows.set(res?.rows ?? []);
          this.total.set(res?.total ?? 0);
          this.segmentCounts.set(res?.segmentCounts ?? {});
        },
        error: () => {
          this.loading.set(false);
          this.failed.set(true);
        },
      });
  }
}
